import { Link } from 'react-router-dom';

export default function TermsPage() {
  return (
    <div className="max-w-2xl mx-auto py-8">
      <h1 className="text-2xl font-bold mb-6">Terms of Service</h1>
      <hr className="mb-6" />

      <p className="text-sm text-muted mb-4">Last updated: February 10, 2026</p>

      <div className="space-y-6 text-sm leading-relaxed">
        <section>
          <h2 className="text-lg font-bold mb-2">1. Acceptance of Terms</h2>
          <p>
            By creating an account on codder.cc ("the Service"), you agree to be bound by these
            Terms of Service. If you do not agree to these terms, please do not register or use
            the Service.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-bold mb-2">2. Account Registration</h2>
          <p>
            To use certain features of the Service, you must register for an account by providing
            a valid email address, username, and password. You agree to:
          </p>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li>Provide accurate and complete registration information</li>
            <li>Maintain the security of your password</li>
            <li>Accept responsibility for all activity under your account</li>
            <li>Notify us immediately of any unauthorized use of your account</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-bold mb-2">3. Email Communications</h2>
          <p>
            By registering, you consent to receive transactional emails from us, including:
          </p>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li>Account verification codes</li>
            <li>Password reset requests</li>
            <li>Important account notifications</li>
          </ul>
          <p className="mt-2">
            These are service-related messages necessary for the operation of your account.
            You may stop receiving these emails by deleting your account.
            We do not send marketing or promotional emails without your explicit opt-in consent.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-bold mb-2">4. User Conduct</h2>
          <p>You agree not to:</p>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li>Use the Service for any unlawful purpose</li>
            <li>Post spam, offensive, or harmful content</li>
            <li>Attempt to gain unauthorized access to other accounts or systems</li>
            <li>Impersonate any person or entity</li>
            <li>Interfere with the proper functioning of the Service</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-bold mb-2">5. Content</h2>
          <p>
            You retain ownership of content you post. By posting content, you grant us a
            non-exclusive license to display it as part of the Service. We reserve the right
            to remove any content that violates these terms.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-bold mb-2">6. Termination</h2>
          <p>
            We may suspend or terminate your account at any time for violation of these terms.
            You may request account deletion by contacting us at{' '}
            <a href="mailto:admin@codder.cc">admin@codder.cc</a>.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-bold mb-2">7. Disclaimer</h2>
          <p>
            The Service is provided "as is" without warranties of any kind. We do not guarantee
            uninterrupted or error-free operation.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-bold mb-2">8. Changes to Terms</h2>
          <p>
            We may update these terms from time to time. Continued use of the Service after
            changes constitutes acceptance of the updated terms.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-bold mb-2">9. Contact</h2>
          <p>
            If you have questions about these terms, contact us at{' '}
            <a href="mailto:admin@codder.cc">admin@codder.cc</a>.
          </p>
        </section>
      </div>

      <hr className="my-6" />
      <p className="text-sm text-muted">
        <Link to="/register">Back to Registration</Link>
        {' | '}
        <Link to="/privacy">Privacy Policy</Link>
      </p>
    </div>
  );
}
